export enum ProjectComponentType {
    BUTTONPANEL,
    SPAREPART
}
